<!-- 积分记录-->
<template>
  <div>
        <ctrl-box class="ctrl-box" ::data="{}">
            <template>
                <div class="xgroup">
                    <el-link :underline="false" @click="showQuery = !showQuery">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-search" font-size="27px;"/>
                            <span class="txt" >{{msg('搜索')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" type="danger" @click="doExport()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-daochu2" font-size="27px;"/>
                            <span class="txt">{{msg('导出')}}</span>      
                        </div>
                    </el-link>
                </div>
            </template>
        </ctrl-box>
 
        <!--查询区域-->
        <transition name="el-zoom-in-top">
            <query-box :query="query" v-show="showQuery" labelWidth="80px">
                <template v-slot:default="scope">
                    <el-form-item :label="msg('开户公司')">
                        <el-input v-model="scope.query.company" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('客户账号')">
                        <el-input v-model="scope.query.username" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('客户名称')">
                        <el-input v-model="scope.query.fullname" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('变动类型')">
                        <el-input v-model="scope.query.type" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('相关单号')">
                        <el-input v-model="scope.query.code" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('变动人')">
                        <el-input v-model="scope.query.createName" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('变动时间')">
                        <el-date-picker  v-model="scope.query.Date" type="daterange"  :range-separator="msg('至')" 
                            value-format="yyyy-MM-dd"
                            end-placeholder=""
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-row>
                        <el-button type="primary" icon="el-icon-search" @click="list" size="mini">{{msg('搜索')}}</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                    </el-row>
                </template>
            </query-box>
        </transition>

        <div class="table-wrap">
            <vxe-grid ref="dataTable" :height="docHeight" 
                export-config
                resizable border="full"
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="pointDetails"
                :columns="columns"
                @cell-click="checkRow"
            ></vxe-grid>

            <pagenator @page-change="handlerPageChange" :query="query" >
            </pagenator>
        </div>

    </div>  
</template>
<script>

import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";

export default {
    name: 'pointDetail',
    components:{
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
    },
    mounted:function(){
        this.list();
    },
    data(){
        return {
            query:{
                length: 10,
                start: 0,
                pageIndex:1,
                pageTotal: 0,
                company:null,
                username:null,
                fullname:null,
                type:null,
                code:null,
                createName:null,
                Date: [],
            },
            showQuery: false,
            columns: [
                {type: 'checkbox', minWidth: 40},
                {field: 'id', title: this.msg('ID'), minWidth: 60, sortable: true},
                {field: 'created', title: this.msg('变动时间'), minWidth:130, sortable: true},
                {field: 'company', title: this.msg('开户公司'), minWidth: 80, sortable: true},
                {field: 'username', title: this.msg('客户账号'), minWidth: 120, sortable: true},
                {field: 'fullname', title: this.msg('客户名称'), minWidth: 120, sortable: true},
                {field: 'type', title: this.msg('变动类型'), minWidth: 120, sortable: true,
                    slots: {
                    // 使用 JSX 渲染
                    default: ({ row }) => {
                            let type = row.type;
                            return [
                                <el-tag type={type==1?'danger':'success'}>{type==1?'过期':'赠送'}</el-tag>
                            ];
                        }
                    }
                },
                {field: 'prePoint', title: this.msg('前积分'), minWidth: 120, sortable: true},
                {field: 'afterPoint', title: this.msg('后积分'), minWidth: 120, sortable: true},
                {field: 'point', title: this.msg('变动积分'), minWidth: 120, sortable: true},
                {field: 'code', title: this.msg('相关单号'), minWidth: 120, sortable: true},
                {field: 'createName', title: this.msg('变动人'), minWidth: 80, sortable: true},
            ],
            pointDetails: [],
            dgTitle: '',
            dgVisible: false,
            curr: null,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
            return this.$store.state.isMinScreen;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    methods: {
        list(){
            var param = this.$kit.rebuildQuery(this.query);

            this.$axios.post(this.$kit.api.pointDetail.list, param)
                .then((result) => {
                    if(result.status){
                        this.pointDetails = result.data.list;
                        this.query.pageTotal = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        //点击行，选中行
        checkRow({row, $event}){
            //如果点击checkbox 则不处理
            if($event.target.className.indexOf("vxe-checkbox--icon")== -1){
                var table =  this.$refs.dataTable;
                table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))
            }
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        doExport(){
            // this.$refs.dataTable.openExport({ isPrint: false })
            this.$refs.dataTable.exportData({ filename:"积分信息",type: 'csv' })
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
